import { linkToParentDashboard } from "../../../links";

export function linkToMorePage() {
  return `${linkToParentDashboard()}/more`;
}
